import Phaser from 'phaser';

export class Button extends Phaser.GameObjects.Container {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    width: number,
    height: number,
    text: string,
    style: 'primary' | 'secondary',
    onClick: () => void
  ) {
    super(scene, x, y);

    const bg = scene.add.graphics();
    
    if (style === 'primary') {
        bg.fillGradientStyle(0xffd700, 0xffd700, 0xd4af37, 0xd4af37, 1);
    } else {
        bg.fillStyle(0x1a1a1a, 1);
        bg.lineStyle(2, 0xd4af37, 1);
        bg.strokeRect(-width/2, -height/2, width, height);
    }
    
    if (style === 'primary') {
        bg.fillRect(-width/2, -height/2, width, height);
    }

    const txt = scene.add.text(0, 0, text, {
        fontSize: '20px',
        color: style === 'primary' ? '#000000' : '#ffffff',
        fontStyle: 'bold'
    }).setOrigin(0.5);

    this.add([bg, txt]);

    this.setSize(width, height);
    this.setInteractive({ useHandCursor: true })
        .on('pointerdown', () => {
            this.setScale(0.95);
            onClick();
        })
        .on('pointerup', () => {
            this.setScale(1.0);
        })
        .on('pointerover', () => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 1.05,
                scaleY: 1.05,
                duration: 100
            });
        })
        .on('pointerout', () => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 1.0,
                scaleY: 1.0,
                duration: 100
            });
        });
  }
}
